import React, { useState } from 'react';
import { formatDistanceToNow } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { API_URL } from '../../lib/api';

const initials = (name) => (name || 'E').split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0]).join('').toUpperCase();
const absUrl = (u) => (u && u.startsWith('/') ? `${API_URL}${u}` : u);

export const relativeDate = (d) => (d ? formatDistanceToNow(new Date(d), { addSuffix: true, locale: ptBR }) : 'agora');

export const CompanyAvatar = ({ name, logo, size = 'w-10 h-10' }) => {
  const [failed, setFailed] = useState(false);
  return (
    <div className={`${size} shrink-0 rounded-full p-[2px] bg-gradient-to-tr from-cyan-500 via-teal-400 to-emerald-400`}>
      <div className="w-full h-full rounded-full bg-white p-[2px]">
        {logo && !failed ? (
          <img src={absUrl(logo)} alt={name} onError={() => setFailed(true)} className="w-full h-full rounded-full object-contain bg-white" data-testid="news-company-logo" />
        ) : (
          <div className="w-full h-full rounded-full bg-cyan-700 text-white flex items-center justify-center text-xs font-bold" data-testid="news-company-initials">
            {initials(name)}
          </div>
        )}
      </div>
    </div>
  );
};

export const NewsPostHeader = ({ news, tipoLabel, unread, light = false, testId }) => (
  <div className="flex items-center gap-3" data-testid={testId}>
    <CompanyAvatar name={news.empresa_nome} logo={news.empresa_logo} />
    <div className="flex-1 min-w-0">
      <p className={`font-semibold text-sm truncate ${light ? 'text-white' : 'text-slate-900'}`} data-testid="news-company-name">
        {news.empresa_nome || 'Empresa'}
      </p>
      <p className={`text-xs ${light ? 'text-cyan-100' : 'text-slate-500'}`}>
        {tipoLabel} · {relativeDate(news.data_publicacao)}
      </p>
    </div>
    {unread && <span className="w-2.5 h-2.5 bg-cyan-500 rounded-full" title="Não lido" />}
  </div>
);
